import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'

import './styles.css'

class UsuarioEdit extends React.Component {

    render() {
        let tipoRol = "";
        tipoRol = (this.props.usuario.tipoRol === 1)?'interno':tipoRol
        tipoRol = (this.props.usuario.tipoRol === 2)?'externo':tipoRol
        
        return (
            <div className='crearEditarUsuario'>

                {/* menú superior */}
                <TitleBar 
                    title={ ((this.props.usuario.id===null)?'Nuevo':'Editar') +' usuario ' + tipoRol} 
                    type='createArticulo'  /** tiene guardar y cancelar */
                    handleOnSave={this.props.handleOnSave} 
                    handleOnBack={this.props.handleOnCancel} 
                    showSearch = {false}
                />
                
                {/**panel usuario interno */}
                {(this.props.usuario.tipoRol === 1) &&
                <Paper className='myBox no-margin'>
                    <Row>
                        <Col md={6}>
                            <TextField className='myInput'        
                                label='Usuario'
                                name='nombreUsuario'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.nombreUsuario}
                                helperText={(this.props.error && this.props.error.nombreUsuario)?this.props.error.nombreUsuario:""}
                                value={this.props.usuario.nombreUsuario}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                        
                        <Col md={6}>
                            <TextField className='myInput'    
                                label='Rol'
                                select
                                error={this.props.error && this.props.error.rol}
                                helperText={(this.props.error && this.props.error.rol)?this.props.error.rol:""}
                                name='rol'
                                fullWidth
                                required
                                value={this.props.usuario.rol}
                                onChange={this.props.handleOnChange}
                                InputLabelProps={{shrink: this.props.usuario.rol!=="" && this.props.usuario.rol!==null}}
                            >
                                {
                                    this.props.roles.map(option => (
                                    <MenuItem key={"rol"+option.descripcion} value={option.descripcion}>
                                        {option.descripcion}
                                    </MenuItem>))
                                }
                            </TextField>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <TextField className='myInput'          
                                label='Nombre'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.nombre}
                                helperText={(this.props.error && this.props.error.nombre)?this.props.error.nombre:""}
                                name='nombre'
                                value={this.props.usuario.nombre}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                        
                        <Col md={6}>
                            <TextField className='myInput'       
                                label='Apellido'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.apellido}
                                helperText={(this.props.error && this.props.error.apellido)?this.props.error.apellido:""}
                                name='apellido'
                                value={this.props.usuario.apellido}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <TextField className='myInput'       
                                label='Email'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.email}
                                helperText={(this.props.error && this.props.error.email)?this.props.error.email:""}
                                name='email'
                                value={this.props.usuario.email}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                        
                    </Row>
                </Paper>
                }
                
                {/**panel usuario externo */}
                { (this.props.usuario.tipoRol === 2) && <React.Fragment>
                <Paper className='myBox no-margin'>
                <Row>
                        <Col md={6}>
                            <TextField className='myInput'          
                                label='Nombre'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.nombre}
                                helperText={(this.props.error && this.props.error.nombre)?this.props.error.nombre:""}
                                name='nombre'
                                value={this.props.usuario.nombre}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                        
                        <Col md={6}>
                            <TextField className='myInput'       
                                label='Apellido'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.apellido}
                                helperText={(this.props.error && this.props.error.apellido)?this.props.error.apellido:""}
                                name='apellido'
                                value={this.props.usuario.apellido}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <TextField className='myInput'       
                                label='Email'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.email}
                                helperText={(this.props.error && this.props.error.email)?this.props.error.email:""}
                                name='email'
                                value={this.props.usuario.email}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                        
                    </Row>

                </Paper>
                
                {/**panel usuario datos del cliente */}
                <Paper className='myBox'>
                    {/*<Row>
                        <Col md={6}>
                            <TextField className='myInput'        
                                disabled
                                label='CUIT'
                                fullWidth
                                name='cliente.cuit'
                                value={this.props.usuario.cliente.cuit}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                        
                        <Col md={6}>
                            <TextField className='myInput'        
                                disabled                
                                label='Razón social'
                                fullWidth
                                name='cliente.razonSocial'
                                value={this.props.usuario.cliente.razonSocial}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <TextField className='myInput'        
                                disabled                      
                                label='Nombre fantasia'
                                fullWidth
                                name='cliente.nombreFantasia'
                                value={this.props.usuario.cliente.nombreFantasia}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                        
                        <Col md={6}>
                            <TextField className='myInput'        
                                disabled                     
                                label='Email'
                                fullWidth
                                name='cliente.datosContacto.correo'
                                value={this.props.usuario.cliente.datosContacto.correo}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                    </Row>*/}
                    <Row>
                        <Col md={6}>
                            <TextField className='myInput'        
                                disabled                    
                                label='Teléfono'
                                fullWidth
                                name='cliente.datosContacto.telefono'
                                value={this.props.usuario.cliente.datosContacto.telefono}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                        <Col md={6}>
                            <TextField className='myInput'        
                                disabled                    
                                label='DNI'
                                fullWidth
                                name='cliente.dni'
                                value={this.props.usuario.cliente.dni}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                    </Row>
                </Paper>
                {/**panel usuario direccion */}
                <Paper className='myBox'>
                    <Row>
                        <Col md={6}>
                            <TextField className='myInput'        
                                disabled
                                label='Provincia'
                                fullWidth
                                name='cliente.datosContacto.calle'
                                value={this.props.usuario.cliente.datosContacto.provincia}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                        
                        <Col md={6}>
                            <TextField className='myInput'        
                                disabled                      
                                label='Localidad'
                                fullWidth
                                name='cliente.datosContacto.numero'
                                value={this.props.usuario.cliente.datosContacto.localidad}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <TextField className='myInput'        
                                disabled
                                label='Dirección'
                                fullWidth
                                name='cliente.datosContacto.calle'
                                value={this.props.usuario.cliente.datosContacto.calle}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>
                        
                        {/*<Col md={6}>
                            <TextField className='myInput'        
                                disabled                      
                                label='Numero'
                                fullWidth
                                name='cliente.datosContacto.numero'
                                value={this.props.usuario.cliente.datosContacto.numero}
                                onChange={this.props.handleOnChange}
                            />
                        </Col>*/}
                    </Row>
                </Paper>
                </React.Fragment>
                }
            </div>
        )
    }
}

UsuarioEdit.propTypes = {
    usuario: PropTypes.object.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,   
    handleOnCancel : PropTypes.func.isRequired
}

UsuarioEdit.defaultProps = {
    catalogos: []
}

export default UsuarioEdit